module.exports = __webpack_public_path__ + "img/52.c8832be6.png";